import CommCdDescModal from './CommCdDescModal';
import CommCdLangModal from './CommCdLangModal';

export default {
	CommCdDescModal,
	CommCdLangModal
};

export { CommCdDescModal, CommCdLangModal };
